'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { UnifiedLayout } from 'DesignData/models/layouts';
import { getNormalizedLayoutData } from 'DesignData/lib/normalization/layouts';
import { LAYOUT_DELETE, LAYOUT_REVISION_FETCH, LAYOUT_REVISIONS_FETCH } from 'DesignData/actions/ActionTypes';

function createLayoutFromRevision(revisionData) {
  const layoutData = getNormalizedLayoutData(revisionData);
  const layout = new UnifiedLayout(revisionData).without('layoutData');
  return {
    layout,
    layoutData
  };
}
/**
 * revisions
 * Stores normalized layout tree data by revision id.
 */


function revisions(state = SeamlessImmutable({
  revisions: {}
}), action) {
  switch (action.type) {
    case LAYOUT_REVISIONS_FETCH:
      {
        const {
          revisions: revs
        } = action;

        if (!revs) {
          return state;
        }

        revs.forEach(revision => {
          if (revision.id !== -1 && state.revisions[revision.id]) {
            // We've already downloaded this revision - it isn't going to change.
            return;
          }

          const revisionData = createLayoutFromRevision(revision.object);
          state = state.setIn(['revisions', revision.id], revisionData);
        });
        return state;
      }

    case LAYOUT_REVISION_FETCH:
      {
        const {
          layout,
          revisionId
        } = action;

        if (!(layout && revisionId)) {
          return state;
        }

        if (revisionId !== -1 && state.revisions[revisionId]) {
          // We've already downloaded this revision - it isn't going to change.
          return state;
        }

        const revisionData = createLayoutFromRevision(layout);
        return state.setIn(['revisions', revisionId], revisionData);
      }

    default:
      return state;
  }
}

function layouts(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case LAYOUT_REVISION_FETCH:
    case LAYOUT_REVISIONS_FETCH:
      {
        const layoutId = action.layoutId || action.resourceId;
        return state.set(layoutId, revisions(state[layoutId], action));
      }

    case LAYOUT_DELETE:
      {
        const {
          layoutId,
          deleted
        } = action;

        if (!deleted) {
          return state;
        }

        return state.without(layoutId);
      }

    default:
      return state;
  }
}

export default combineReducers({
  layouts
});